var _pattern, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallpaperBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#080708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#695C77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#080708"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "waveGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#080708"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#695C77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#080708"
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "linePattern",
    x: 0,
    y: 0,
    width: 4,
    height: 1,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 4,
    y2: 0,
    stroke: "#695C77",
    strokeWidth: 0.5,
    opacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#skyGradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 300,
    r: 400,
    stroke: "#695C77",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-100 600 C 300 550, 800 750, 1200 600 S 1800 550, 2100 600 V 1200 H -100 Z",
    fill: "url(#waveGradient)",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 650 C 400 600, 900 800, 1300 650 S 1900 600, 2100 650 V 1200 H -100 Z",
    fill: "url(#waveGradient)",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 700 C 500 650, 1000 850, 1400 700 S 2000 650, 2100 700 V 1200 H -100 Z",
    fill: "url(#waveGradient)",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 600 C 300 550, 800 750, 1200 600 S 1800 550, 2100 600 V 1200 H -100 Z",
    fill: "url(#linePattern)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 650 C 400 600, 900 800, 1300 650 S 1900 600, 2100 650 V 1200 H -100 Z",
    fill: "url(#linePattern)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-100 700 C 500 650, 1000 850, 1400 700 S 2000 650, 2100 700 V 1200 H -100 Z",
    fill: "url(#linePattern)",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpaperBackground);
export default __webpack_public_path__ + "static/media/wallpaper_background.5db9a64dcb1c677ba55c1a6b0ebae608.svg";
export { ForwardRef as ReactComponent };